import React from 'react';
import { PublicFooter } from './PublicFooter';

/** @deprecated Use PublicFooter variant="full" — kept for existing imports. */
export function PublicSiteFooter(props) {
  return <PublicFooter variant="full" {...props} />;
}

export default PublicSiteFooter;
